export default "__VITE_ASSET__7bx3XutY__"